import {interval, Observable} from 'rxjs';
import {filter, share, tap} from 'rxjs/operators';
import {DataPulseProvider} from './data-pulse-provider';

import {HistoryProvider} from './history-provider';

const DEFAULT_UPDATE_FREQUENCY = 10 * 1000;
const UPDATES_GATING$ = interval(DEFAULT_UPDATE_FREQUENCY).pipe(
    share()
);
const updatesQueue: any[] = [];

export const getUpdatesQueueStream = (): Observable<any> => {
    const consumerMark = {};

    return UPDATES_GATING$.pipe(
        (source: Observable<number>) => {
            updatesQueue.push(consumerMark);

            return source;
        },
        filter(gatingCounter => {
            const consumerIndex = updatesQueue.indexOf(consumerMark);

            return gatingCounter % updatesQueue.length === consumerIndex;
        })
    );
};

export class DataPulseProviderThrottled extends DataPulseProvider {

    public constructor(historyProvider: HistoryProvider, updateFrequency: number) {
        super(historyProvider, updateFrequency);

        this.interval$ = getUpdatesQueueStream().pipe(
            tap(() => this.updateData()),
            share()
        );
    }

}
